export default __webpack_public_path__ + "static/media/icon-pdf-download.873cebf2.svg";